import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element } from '@shared/easyfy.core';
import myPagesService from '@webServices/mypages.service';

namespace Easyfy.Web.Pages {
  @invoke
  class MyBoughtProducts {
    static instance: MyBoughtProducts;

    static loaderString =
      '<div class="loader m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

    static loaderContainerElement: HTMLElement;

    static boughtProductListContainer: HTMLElement;

    static loadProductsElement: HTMLElement;

    static sorterContainer: HTMLElement;

    constructor() {
      MyBoughtProducts.instance = this;
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'load-products',
          callback: MyBoughtProducts.showMoreProducts
        }
      });
      MyBoughtProducts.loaderContainerElement = element(
        '[data-container="loader-container"]'
      ) as HTMLElement;

      MyBoughtProducts.boughtProductListContainer = element(
        '[data-container="bought-products-list"]'
      ) as HTMLElement;

      MyBoughtProducts.loadProductsElement = element(
        '[data-action="load-products"]'
      ) as HTMLElement;

      MyBoughtProducts.sorterContainer = element(
        '[data-container="sorter"]'
      ) as HTMLElement;

      document.addEventListener('bought-products-change-sort-option', (e) => {
        MyBoughtProducts.changeSort(e);
      });
    }

    static showMoreProducts = () => {
      MyBoughtProducts.loaderContainerElement.innerHTML =
        MyBoughtProducts.loaderString;
      const currentPage =
        MyBoughtProducts.loadProductsElement.getAttribute('data-current-page');
      const nextPage = Number(currentPage) + 1;
      const sortOrder = MyBoughtProducts.sorterContainer
        .querySelectorAll('.select-item.selected')[0]
        .getAttribute('data-value');

      MyBoughtProducts.loadProducts(sortOrder, nextPage);
    };

    private static changeSort = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      const selectedElement: HTMLSelectElement = e.target as HTMLSelectElement;
      const selectedValue = selectedElement.value;

      const sorterContainer = element(
        '[data-container="sorter"]'
      ) as HTMLElement;
      // Remove 'selected' class from all siblings

      if (sorterContainer) {
        const allItems = sorterContainer.querySelectorAll('.select-item');

        allItems.forEach((item) => {
          if (item.getAttribute('data-value') === selectedValue) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
        });
      }

      // Add 'selected' class to the clicked item
      selectedElement.classList.add('selected');
      MyBoughtProducts.boughtProductListContainer.innerHTML =
        MyBoughtProducts.loaderString;
      MyBoughtProducts.loadProducts(selectedValue, 1);
    };

    static loadProducts(sortOrder: string, nextPage: number) {
      myPagesService
        .GetBoughtProducts(sortOrder, nextPage)
        .then((response) => {
          if (response.status !== 200 || response.data.success === false) {
            MyBoughtProducts.loaderContainerElement.innerHTML = '';
            return;
          }

          if (nextPage !== 1) {
            MyBoughtProducts.loaderContainerElement.innerHTML = '';
            MyBoughtProducts.boughtProductListContainer.insertAdjacentHTML(
              'beforeend',
              response.data.boughtProductsPartial
            );
          } else {
            MyBoughtProducts.boughtProductListContainer.innerHTML =
              response.data.boughtProductsPartial;
          }

          MyBoughtProducts.loadProductsElement.setAttribute(
            'data-current-page',
            response.data.page
          );

          if (response.data.showMore === false) {
            MyBoughtProducts.loadProductsElement.remove();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
}

export default Easyfy.Web.Pages;
